export default __webpack_public_path__ + "static/media/logo.fccc8998.png";